import { MessageBox } from 'element-ui'

export function setCookie(key, val, time) {
  var date = new Date() //获取当前时间
  var expiresDays = time //将date设置为n天以后的时间
  date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000) //格式化为cookie识别的时间
  document.cookie =
    key + '=' + val + ';expires=' + date.toGMTString() + ';path=/' //设置cookie
}

export function getCookie(key) {
  /*获取cookie参数*/
  var getCookie = document.cookie.replace(/[ ]/g, '') //获取cookie，并且将获得的cookie格式化，去掉空格字符
  var arrCookie = getCookie.split(';') //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中

  var tips //声明变量tips
  for (var i = 0; i < arrCookie.length; i++) {
    //使用for循环查找cookie中的tips变量
    var arr = arrCookie[i].split('=') //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
    if (key == arr[0]) {
      //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
      tips = arr[1] //将cookie的值赋给变量tips
      break //终止for循环遍历
    }
  }

  return tips
}

export function clearCookie(name) {
  setCookie(name, '', -1)
}

export function formDataTime(time) {
  const dateTime = new Date(time * 1000)
  const year = dateTime.getFullYear()
  let month = dateTime.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  let date = dateTime.getDate()
  date = date < 10 ? `0${date}` : date
  let hours = dateTime.getHours()
  hours = hours < 10 ? `0${hours}` : hours
  let minutes = dateTime.getMinutes()
  minutes = minutes < 10 ? `0${minutes}` : minutes
  time = `${year}年${month}月${date}日 ${hours}:${minutes}`
  return time
}

export function formDataTimeDay(time) {
  const dateTime = new Date(time * 1000)
  const year = dateTime.getFullYear()
  let month = dateTime.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  let date = dateTime.getDate()
  date = date < 10 ? `0${date}` : date
  time = `${month}月${date}日`
  return time
}

export function formDataTimeMinutes(time) {
  const dateTime = new Date(time * 1000)
  const year = dateTime.getFullYear()
  let month = dateTime.getMonth() + 1
  month = month < 10 ? `0${month}` : month
  let date = dateTime.getDate()
  date = date < 10 ? `0${date}` : date
  let hours = dateTime.getHours()
  hours = hours < 10 ? `0${hours}` : hours
  let minutes = dateTime.getMinutes()
  minutes = minutes < 10 ? `0${minutes}` : minutes
  time = `${month}月${date}日 ${hours}:${minutes}`
  return time
}

export function timeStamp(second_time) {
  let day = 0
  let hour = 0
  let min = 0
  let second = 0
  if (second_time === null || second_time === undefined) {
    return { day, hour, min, second }
  }
  second = parseInt(second_time)
  if (parseInt(second_time) >= 60) {
    second = parseInt(second_time) % 60
    min = parseInt(second_time / 60)
    if (min >= 60) {
      min = parseInt(second_time / 60) % 60
      hour = parseInt(parseInt(second_time / 60) / 60)
      if (hour >= 24) {
        hour = parseInt(parseInt(second_time / 60) / 60) % 24
        day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24)
      }
    }
  }

  return { day, hour, min, second }
}

export function isStudy() {
  MessageBox.alert('您的学员状态已过期', '提示', {
    type: 'warning',
    confirmButtonText: '确定',
    callback: (action) => {},
  })
  return false
}

// 防抖
export const throttle = (fn, delay) => {
  var lastTimestamp = new Date().getTime()
  return function () {
    var args = arguments
    var _this = this
    var currentTimestamp = new Date().getTime()
    if (currentTimestamp - lastTimestamp > delay) {
      fn.apply(_this, args)
      lastTimestamp = currentTimestamp
    }
  }
}

// 节流
export const debounce = (fn, delay) => {
  var timer = null
  return function () {
    const args = arguments
    const _this = this
    // 判断是否正在计时，如果在计时则重新计时。
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      fn.apply(_this, args)
      timer = null
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js